import styled,{css} from 'styled-components';
import {ReactComponent as Heart} from '../../assets/icons/redHeart.svg';
import {ReactComponent as Compare} from '../../assets/icons/compare.svg';


export const Container = styled.div`
display: flex;
flex-direction:${({main})=>main ? 'column' : 'row'};
box-sizing: border-box;
width:100%;
padding: 64px 0px 0 0px ;
font-family: Open Sans;
font-style: normal;
font-weight: normal;
color: #151515;

`
export const Image = styled.div`
background: #F9F9F9;
border-radius: 12px;
height:436px;
margin-right: 32px;
flex: 1;
`

const saleTag = css`
position: absolute;
margin-right: 30px;
display: flex;
flex-direction: row;
margin:16px 0 0 16px;
width: 173px;

`
const Category = css`
width:269px;
display: flex;
margin: 0  52px 12px 0 ;
`
const button = css`
display: flex;
align-items: center;
background: #FFFFFF;
border: 1px solid #F5F5F5;
box-sizing: border-box;
border-radius: 12px;
margin-top: 40px;
padding: 16px;
`
const Action = css`
display: flex;
align-items: center;
width: 328px;
height: 35px;
margin-top: 24px;
`
const Wishlist = css`
display: flex;
align-items: center;
font-family: Poppins;
font-style: normal;
font-weight: bold;
font-size: 15px;
line-height: 22px;
color: #151515;
`
const ButtonWrap = css`
display: flex;
align-items: center;
margin-left: 132px;
`
 
export const Wrapper = styled.div`
${({sale})=>sale && saleTag}
width: 570px;
flex: 1;
display: ${({rating})=>rating && 'flex'};
display:${({mainCategory})=>mainCategory && 'flex'};
${({category})=>category && Category};
${({buttonWrapper})=>buttonWrapper && button};
flex-direction:${({price})=>price && 'column'};
${({action})=> action && Action};
${({wishlist})=>wishlist && Wishlist};
${({button})=>button && ButtonWrap};
`
const header = css`
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 32px;
line-height: 140%;
color: #151515;
margin-bottom: 8px;

`
const description = css`
font-size: 17px;
line-height: 23px;
color: #151515;
width: 569px;
margin: 40px 0;
`
const CategoryTitle = css`
font-size: 14px;
line-height: 19px;
color: #A9A9A9;
margin-right: 72px;
width: 80px;
`
const CategoryDesc = css`
font-size: 14px;
line-height: 19px;
`
const color = css`
color: #6A983C;
`
const Price = css`
font-weight: 600;
font-size: 26px;
line-height: 39px;
color: #6A983C;
font-family: Poppins;
font-style: normal;
`
const discountStyle = css`
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 18px;
text-decoration-line: line-through;
color: #A9A9A9;

`
export const Title = styled.div`
${({title})=>title && header};
${({desc})=> desc && description};
${({categoryTitle})=>categoryTitle && CategoryTitle};
${({categoryDesc})=>categoryDesc && CategoryDesc};
${({stock})=>stock && color};
${({price})=> price && Price};
${({discount})=>discount && discountStyle};
`
export const Review = styled.div`
font-family: Open Sans;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 16px;
text-decoration-line: underline;
color: #A9A9A9;
margin-left: 80px;
`
export const Discount = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
background: #F4F8EC;
border-radius: 12px;
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 18px;
color: #6A983C;
margin-left: 22px;
padding: 4px 10px;
`


export const Input = styled.div`

`
export const Button = styled.button`
cursor: pointer;
width:20px;
height:20px;
border-radius:50px;
margin: 0 10px ;
` 

export const AddButton = styled.button`
background: #6A983C;
border: 2px solid #46760A;
box-sizing: border-box;
border-radius: 12px;
width: 140px;
margin-right: 8px;
height: 47px;
font-weight: bold;
font-size: 15px;
line-height: 22px;
color: #FFFFFF;
cursor: pointer;
:hover{
    background-color:#118534;
}
:active{
transform: scale(.95);
background-color:#0e752d;
color: white;
box-shadow: 1px 10px 1px 10 px #13943a;
}
`

export const Icons = styled.div`
`

Icons.HeartIcon = styled(Heart)`
width: 16px;
margin-right:  6px;
cursor: pointer;
:hover{
fill: red;
}
:active{
transform: scale(1.50);
}

`
Icons.Compare = styled(Compare)`
cursor: pointer;
width: 16px;
margin-left: 28px;
margin-right: 6px;
:hover{
fill: red;
}
:active{
transform: scale(1.50);
}
`